import React from 'react'
import DateInputBase from './DateInputBase'
const YearInput = (props) => {
    const handleChange = (setInternalVal) => (e) => {
        const textVal = e.target.value
        let val

        // const parseYear = moment('01-01-'+val).format(props.format)
        // console.log('PARASE', parseYear)

        if (textVal === '') {
            val = null
        } else {
            val = parseInt(e.target.value)

            if (val.toString().length > props.format.length) {
                return
            }

            if (!(val <= 9999)) {
                return
            }
        }
        if (textVal.length === props.format.length) {
            props.focusNextInput()
        }

        setInternalVal(textVal)
    }

    return (
        <DateInputBase
            {...props}
            value={props.value || ''}
            placeholder={props.format.toUpperCase()}
            onChange={props.onChange}
            displayValue={(internalVal) => {
                return internalVal.toString().slice(props.format.length * -1)
            }}
            handleInternalChange={handleChange}
            onBlur={(val, setFinalValue, clearInput) => {
                if (val.toString().length !== props.format.length) {
                    setFinalValue('')
                    return
                }

                if (val.toString().length === 2) {
                    setFinalValue('20' + val.toString())
                }
                setFinalValue(val.toString())
            }}
        />
    )
}

export default YearInput
